import { JSX, useContext, useState } from "react";
import { toast } from "react-toastify";
import { QESButton } from "@app/shared/qes-standards";
import { FlyoutContext, FlyoutFooter } from "@app/shared/Flyouts";

interface TerminationsWizardFlyoutProps {
  onSubmit: () => Promise<boolean>;
}

const TerminationsWizardFlyout = (props: TerminationsWizardFlyoutProps): JSX.Element => {
  const [submitting, setSubmitting] = useState(false);
  const flyoutContext = useContext(FlyoutContext);

  const errorMessage = () => {
    toast("Something went wrong. Please try again later.",
      {
        containerId: "z-index-9999",
        type: "error",
      });
    setSubmitting(false);
  };

  const handleSubmit = () => {
    if (submitting) {
      return;
    }
    setSubmitting(true);
    props.onSubmit().then((result: boolean) => {
      if (result) {
        toast("Your terminations are being processed.", {
          containerId: "z-index-9999",
          type: "success",
        });
        flyoutContext.handleCloseFlyout();
      } else {
        errorMessage();
      }
    },
      () => { errorMessage(); });
  };
  
  return (
    <>
      <div className="terminations-wizard-flyout">
        <p className="lead"><i className="fa fa-exclamation-triangle d-inline-block mr-3" />Are you sure?</p>
        <hr />
        <div>
          <p>While the termination is running the projects you selected will no longer be able to:</p>
          <ul>
            <li>Make changes</li>
            <li>Make updates</li>
            <li>Generate additional terminations</li>
          </ul>
          <p>Any project with existing terminations will be overwritten and not appended.</p>
          <p className="font-weight-bold">Once the termination has been started there will be no way to cancel it.</p>
        </div>
      </div>
      <FlyoutFooter
        submitButton={
          <QESButton qesType="primary" className="ml-3" onClick={handleSubmit} disabled={submitting} qesTestId="import-terminations__flyout-run">
            {submitting ? (
              <div className="spinner-border spinner-border-sm" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            ) : "Run Now"}
          </QESButton>
        }
      />
    </>
  );
};

export default TerminationsWizardFlyout;
